<div class="principal">
	<img src="../../../../assets/images/logo-load.png" alt="search" />
	<h2>Links</h2>
	<p>Debes seleccionar un Link, o bien, crear uno nuevo</p>
</div>
